import { $, $$ } from '@utils';

function init() {
  if (!$('[data-au-calendar-card]')) return;

  addEventListeners();
}

function addEventListeners() {
  const textContent = $$('[data-au-calendar-card-text]');

  textContent.forEach((text) => {
    const seeMore = document.createElement('a');
    seeMore.className = 'au-link au-calendar-card__description-link';
    seeMore.setAttribute('data-au-calendar-more', '');
    seeMore.innerText = 'Leer más';
    seeMore.href = 'javascript:void(0);';
    if (text.offsetWidth < text.scrollWidth) {
      text.closest('[data-au-calendar-card-description]').appendChild(seeMore);

      seeMore.addEventListener('click', () => {
        if (text.classList.contains('show-more')) {
          text.classList.remove('show-more');
          seeMore.innerText = 'Leer más';
        } else {
          text.classList.add('show-more');
          seeMore.innerText = 'Leer menos';
        }
      });
    }
  });
}

export default { init };
